import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import PruebaConocimientoCardImg from "../../components/UmmIApps/Cards/PruebaConocimientoCardImg.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AgregarTipoPreguntas from "../../components/Form/Fields/AgregarTipoPreguntas";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionMiniTest from "../../components/Form/Fields/DuracionMiniTest";
import TemaEvaluacion from "../../components/Form/Fields/TemaEvaluacion";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const PruebaConocimientoPage = () => {
  const {
    materiaId,
    nivelId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    isOAAdded,
    handleInitialPromptData,
  } = useActividadesContext();
  const [isPreguntaAdded, setIsPreguntaAdded] = useState(false)

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema_evaluacion &&
    isPreguntaAdded &&
    promptData.cantidad_tiempo &&
    isOAAdded
  );
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      nivel: "",
      materia: "",
      objetivos: [],
      preguntas: {
        tipoPreguntas: "",
        cantidadPreguntas: 1,
      },
      cantidad_tiempo: 5,
      caracterizacion: "",
      condiciones_contexto: "",
      tema_evaluacion: "",
    };
    handleInitialPromptData(init, "test");
    setTextoInicial(
      "A continuación te propongo algunas preguntas para tu evaluación. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  
  useEffect(() => {
    console.log(isPreguntaAdded);
    
  }, [isPreguntaAdded]);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={PruebaConocimientoCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Prueba de conocimiento"
        description="Crea pruebas de conocimiento que permitan medir el progreso de los estudiantes en relación con los objetivos de aprendizaje establecidos."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TemaEvaluacion />
        </Grid>
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Grid item lg={12}>
            <AgregarTipoPreguntas setIsPreguntaAdded={setIsPreguntaAdded}/>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          display={"flex"}
          flexDirection={"row"}
          sx={{ mt: 4 }}
        >
          <Grid item lg={12}>
            <DuracionMiniTest />
          </Grid>
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Caracterizacion />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default PruebaConocimientoPage;
